import React from 'react'
import { Box } from '@mui/material'

import type { IBlockPayloadContent } from '../../../types'

export const ContentRenderer: React.FC<{ payload: IBlockPayloadContent }> = ({ payload }) => {
  if (!payload.html) return null
  return (
    <Box
      sx={{
        '& img': { maxWidth: '100%', height: 'auto' },
        '& a': { color: 'primary.main' },
      }}
      dangerouslySetInnerHTML={{ __html: payload.html }}
    />
  )
}
